// #region Constantes armazenamento
const LS_KEY = 'produtos.data.v1';
// #endregion

// #region Util persistência
function loadAll() {
  const raw = localStorage.getItem(LS_KEY);
  if (!raw) return [];
  try { return JSON.parse(raw); } catch { return []; }
}
function persist(list) { localStorage.setItem(LS_KEY, JSON.stringify(list)); }
function delay(ms = 250) { return new Promise(r => setTimeout(r, ms)); }
// #endregion

// #region Leitura / Listagem
export async function getAllProdutos() { await delay(); return loadAll(); }
export async function listProdutos({ search = '', page = 1, pageSize = 10 } = {}) {
  await delay();
  const all = loadAll();
  const term = search.trim().toLowerCase();
  const filtered = term ? all.filter(p => [p.nome, p.marca, p.lote].some(f => (f || '').toLowerCase().includes(term))) : all;
  const total = filtered.length;
  const start = (page - 1) * pageSize;
  const pageItems = filtered.slice(start, start + pageSize);
  return { items: pageItems, total };
}
// #endregion

// #region Mutação
export async function createProduto(data) {
  await delay();
  const all = loadAll();
  const id = all.length ? Math.max(...all.map(p => p.id)) + 1 : 1;
  const novo = { id, ...data };
  all.push(novo);
  persist(all);
  return novo;
}
export async function updateProduto(id, data) {
  await delay();
  const numericId = Number(id);
  const all = loadAll();
  const idx = all.findIndex(p => p.id === numericId);
  if (idx === -1) throw new Error('Produto não encontrado');
  all[idx] = { ...all[idx], ...data, id: numericId };
  persist(all);
  return all[idx];
}
export async function deleteProduto(id) {
  await delay();
  const remaining = loadAll().filter(p => p.id !== id);
  persist(remaining);
  return true;
}
// #endregion
